import { getPath } from '@/router/common'

const baseUrl = {
  title: '出纳审核',
  path: 'News'
}

export default [
  {
    path: getPath('F9', baseUrl),
    name: 'News_F9',
    component: () => import(/* webpackChunkName: "News_F9" */ '@/views/news/f9/index.vue'),
    meta: {
      title: '蓝桥F9介绍'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'News_Index',
    component: () => import(/* webpackChunkName: "News_Index" */ '@/views/news/index/index.vue'),
    meta: {
      title: '公司公告'
    }
  },
]
